module.exports = __webpack_public_path__ + "img/userMedia.2081bfe8.png";